<template>
	<div :class="['loading-container', loading ? 'loading' : '']">
		<div class="loader-blur" v-if="loading"></div>
		<div class="loader" v-if="loading"></div>
		<slot />
	</div>
</template>
<script>
export default {
	name: "YwLoading",
	props: {
		loading: {
			type: Boolean,
			default: true,
		},
		// 大小  可选值为 small default large
		size: {
			type: String,
			default: "default",
		},
		// 位置  可选值为 center top
		position: {
			type: String,
			default: "center",
		},
		minHeight: {
			type: String,
			default: "",
		},
	},
	computed: {
		boxStyle() {
			return this.boxSize[this.size];
		},
		shadowStyle() {
			return this.shadowSize[this.size];
		},
		getTop() {
			return this.position === "center" ? "50%" : "10px";
		},
		getCenter() {
			return this.position === "center" ? "-50%" : "0";
		},
		getSize() {
			return this.LoadingSize[this.size];
		},
		setContainerHeight() {
			return this.minHeight
				? `${this.minHeight}px`
				: `${parseInt(this.getSize, 10) + 20}px`;
		},
	},
	data() {
		return {
			LoadingSize: {
				small: "20px",
				default: "30px",
				large: "40px",
			},
		};
	},
};
</script>
<style lang="less" scoped>
.loading-container {
	position: relative;
	min-height: v-bind(setContainerHeight);

	&.loading {
		overflow: hidden;
		user-select: none;
		pointer-events: none;
	}
	.loader-blur {
		width: 100%;
    min-height: v-bind(setContainerHeight);
		height: 100%;
		background: #fff;
		opacity: 0.6;
		position: absolute;
		top: 0;
		left: 0;
		clear: both;
		overflow: hidden;
		user-select: none;
		pointer-events: none;
		z-index: 9999;
	}
}
.loader {
	width: v-bind(getSize);
	height: v-bind(getSize);
	position: absolute;
	z-index: 9999;
	top: v-bind(getTop);
	left: 50%;
	filter: opacity(100%);
	transform: translate(-50%, v-bind(getCenter));
}
.loader:before {
	content: "";
	width: v-bind(getSize);
	height: 5px;
	background: #000;
	opacity: 0.25;
	position: absolute;
	top: calc(v-bind(getSize) + 15px);
	left: 0;
	border-radius: 50%;
	animation: shadow 0.5s linear infinite;
	z-index: 9999;
}
.loader:after {
	content: "";
	width: 100%;
	height: 100%;
	background: #5286ec;
	animation: bxSpin 0.5s linear infinite;
	position: absolute;
	top: 0;
	left: 0;
	border-radius: 4px;
	z-index: 9999;
}

@keyframes bxSpin {
	17% {
		border-bottom-right-radius: 3px;
	}
	25% {
		transform: translateY(9px) rotate(22.5deg);
	}
	50% {
		transform: translateY(18px) scale(1, 0.9) rotate(45deg);
		border-bottom-right-radius: 40px;
	}
	75% {
		transform: translateY(9px) rotate(67.5deg);
	}
	100% {
		transform: translateY(0) rotate(90deg);
	}
}

@keyframes shadow {
	0%,
	100% {
		transform: scale(1, 1);
	}
	50% {
		transform: scale(1.2, 1);
	}
}
</style>
